import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

class Chip extends PureComponent {
    state = {};

    render() {
        const { children, onClick = () => null, className = '' } = this.props;

        const classes = ['react-chip'];
        if (className) classes.push(className);

        return (
            <div role="button" tabIndex="-1" className={classes.join(' ')} onClick={onClick}>
                {children}
            </div>
        );
    }
}

Chip.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Chip;
